import { z } from "zod";
import { localDateSchema, moneySchema, quantitySchema, timestampSchema, uuidSchema, } from "../common/primitives.js";
import { fuelPaymentTypeSchema } from "./readings.js";
/**
 * Satış özet tabloları. TimescaleDB continuous aggregate KULLANILMAZ (RLS'li hypertable üzerinde oluşturulamıyor
 * ve cagg'ler kiracı bağlamı taşımıyor — docs/wip-prompt-12.md); yerine RLS'li ÖZET TABLOLARI vardır ve alım
 * servisi dokunulan kovaları aynı transaction'da ham veriden yeniden hesaplar.
 */
/** Bir sorguda dönebilecek en çok özet satırı. */
export const MAX_FUEL_SUMMARY_ROWS = 5000;
export const fuelSalesHourlyQuerySchema = z.object({
    stationId: uuidSchema,
    from: timestampSchema,
    to: timestampSchema,
    nozzleId: uuidSchema.optional(),
    tankId: uuidSchema.optional(),
    productId: uuidSchema.optional(),
});
export const fuelSalesHourlyRowSchema = z.object({
    stationId: uuidSchema,
    nozzleId: uuidSchema,
    tankId: uuidSchema,
    productId: uuidSchema,
    /** Saat başı (UTC). */
    bucket: timestampSchema,
    litres: quantitySchema.describe("Test HARİÇ satılan litre"),
    amount: moneySchema,
    transactionCount: z.number().int().nonnegative(),
    testLitres: quantitySchema,
});
export const fuelSalesHourlySchema = z.object({
    stationId: uuidSchema,
    from: timestampSchema,
    to: timestampSchema,
    items: z.array(fuelSalesHourlyRowSchema),
});
export const fuelSalesDailyQuerySchema = z.object({
    stationId: uuidSchema.optional().describe("Verilmezse şirketin görünür istasyonları"),
    companyId: uuidSchema.optional(),
    from: localDateSchema,
    to: localDateSchema,
    productId: uuidSchema.optional(),
});
/**
 * Ödeme türü → toplamlar. `partialRecord`: o gün GÖRÜLEN türler bulunur, hepsi zorunlu DEĞİLDİR
 * (`z.record` Zod 4'te enum anahtarlarının tamamını şart koşar).
 */
export const fuelPaymentBreakdownSchema = z.partialRecord(fuelPaymentTypeSchema, z.object({ litres: quantitySchema, amount: moneySchema, transactionCount: z.number().int().nonnegative() }));
export const fuelSalesDailyRowSchema = z.object({
    companyId: uuidSchema,
    stationId: uuidSchema,
    productId: uuidSchema,
    businessDate: localDateSchema,
    litres: quantitySchema.describe("Test HARİÇ satılan litre"),
    amount: moneySchema,
    transactionCount: z.number().int().nonnegative(),
    testLitres: quantitySchema,
    testReturnedLitres: quantitySchema.describe("Test çekişinin tanka geri dökülen kısmı"),
    byPaymentType: fuelPaymentBreakdownSchema,
});
export const fuelSalesDailySchema = z.object({
    from: localDateSchema,
    to: localDateSchema,
    items: z.array(fuelSalesDailyRowSchema),
});
//# sourceMappingURL=summaries.js.map